import React, { useContext } from "react"
import { memberSystemLink } from "api"
import styled from "styled-components"
import cx from "classnames"
import { ContextStore } from "Reducer"
import { List } from "immutable"
import media from "cssMix/index"
import noop from "lodash"

// util
import { gameLinkLang } from "Utils/index"

const StyledNewMenu = styled.div`
  width: 100%;
  & .container {
    color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    width: 100%;
    height: 40px;
    margin: 0 0 16px;
    padding: 10px 12px;
    border-radius: 6px;
    border: solid 1px rgba(249, 190, 0, 0.37);
    background-color: #322b6e;
    font-size: 15px;
    cursor: pointer;
    & .title {
      display: flex;
      align-items: center;
    }
    & .num {
      font-size: 13px;
      color: #f9be00;
    }
    & .icon {
      margin-right: 5px;
      font-size: 17px;
      color: #f9be00;
    }
    &.top {
      border-radius: 6px 6px 0 0;
      margin-bottom: 0;
      margin-top: 32px;
    }
    &.down {
      border-radius: 0 0 6px 6px;
      border-top: 0;
    }
    &.focus {
      background-color: #fff;
      color: #000;
      & .num {
        color: #f4265a;
      }
      & .icon {
        margin-right: 5px;
        font-size: 17px;
        color: #f4265a;
      }
    }
  }
  ${media.tablet`

  `}
`

const NewMenu = ({ t, mainAreaRoute, dispatch, hamHandler = noop }) => {
  const menuClickHandler = (type, data) => {
    if(data.clickEvent){
      data.clickEvent()
      return
    }
    dispatch({ type: "CHANGE_DATA", path: "mainAreaRoute", value: type })
  }
  const {
    state: { stateReducer },
  } = useContext(ContextStore)
  const lang = stateReducer.get("lang")
  const hasCQ9VIPClub = stateReducer.get("hasCQ9VIPClub")
  const gameList = stateReducer.get("gameList", List())
  const favorite_game = stateReducer.getIn(
    ["userInfo", "favorite_game"],
    List()
  )
  const filteredFavoriteGameList = gameList.filter((v) =>
    favorite_game.includes(v.get("game_id"))
  )
  const recent_game =
    stateReducer.getIn(["userInfo", "recent"], List()) || List()
  const menuList = [
    {
      id: 1,
      type: "Lobby",
      name: "gameLobby",
      gaClass: "gav2_menu_home",
      icon: "bxs-home-alt-2",
      needNum: false,
    },
    {
      id: 2,
      type: "Favorite",
      name: "myFollowedGames",
      gaClass: "gav2_menu_favorite",
      icon: "bxs-heart",
      needNum: true,
      num: filteredFavoriteGameList.size,
    },
    {
      id: 3,
      type: "Recent",
      name: "recentPlayed",
      gaClass: "gav2_menu_recently",
      icon: "bxs-time-five",
      needNum: true,
      num: recent_game.size,
    },
    (() => {
      return hasCQ9VIPClub ? {
        id: 6,
        type: "CQ9 VIP Club",
        name: "CQ9 VIP Club",
        icon: "bxs-user",
        // gaClass: "gav2_menu_ranking",
        needNum: false,
        clickEvent: () => memberSystemLink(gameLinkLang(lang))
      } : null
    })(),
    {
      id: 4,
      type: "PayoutRank",
      name: "payoutRank",
      gaClass: "gav2_menu_payout",
      needNum: false,
    },
    {
      id: 5,
      type: "PlayerRank",
      name: "playerRank",
      gaClass: "gav2_menu_ranking",
      needNum: false,
    },
  ]
  return (
    <StyledNewMenu>
      {menuList.filter(Boolean).map((v) => (
        <div
          className={cx([
            `container ${v.gaClass}`,
            {
              focus: mainAreaRoute === v.type,
              top: v.id === 4,
              down: v.id === 5,
            },
          ])}
          key={v.id}
          onClick={() => {
            menuClickHandler(v.type, v)
            hamHandler()
          }}
        >
          <div className="title">
            <div className={`bx icon ${v.icon}`} />
            <p>{t(v.name)}</p>
          </div>
          {v.needNum && <p className="num">{v.num}</p>}
        </div>
      ))}
    </StyledNewMenu>
  )
}

export default NewMenu
